import { useCallback, useState } from 'react';

import type { GroupConnectionRequestPayload } from './types';

/**
 * Хук для психолога: хранит список участников, запросивших подключение (Data Channel),
 * и возвращает callback для LiveKit и производные данные для панели.
 */
export function useGroupConnectionAwaiting() {
  const [awaitingList, setAwaitingList] = useState<GroupConnectionRequestPayload[]>([]);

  const onGroupConnectionRequest = useCallback((payload: GroupConnectionRequestPayload) => {
    setAwaitingList((prev) => {
      const exists = prev.some((p) => p.identity === payload.identity);
      if (exists) return prev;
      return [...prev, payload];
    });
  }, []);

  const removeAwaiting = useCallback((identity: string) => {
    setAwaitingList((prev) => prev.filter((p) => p.identity !== identity));
  }, []);

  const clearAwaiting = useCallback(() => {
    setAwaitingList([]);
  }, []);

  return {
    awaitingList,
    awaitingCount: awaitingList.length,
    onGroupConnectionRequest,
    removeAwaiting,
    clearAwaiting,
  };
}
